import React, { useCallback } from 'react';

import { rolesRoute } from '~/routes'
import CrudLayoutList from '~/containers/CrudLayoutList';
import roleSchema from '~/records/schema/roleSchema';
import { useDispatch, connect } from 'react-redux';
import { fetchRecords, destroyRecord } from '~/store/modules/roles';

function List({isLoading, rows, total}) {
  const dispatch = useDispatch();

  const handleFetch = useCallback(
    async (params, requestSource) => {
      dispatch( fetchRecords(params, requestSource) )
    },
    [],
  )

  const onDelete = useCallback(
    async (row) => {
      dispatch( destroyRecord(row.id) )
    },
    []
  )

  return (
    <CrudLayoutList
      breadcrumbs={[{ text: 'Permissões' }]}
      permissionKeyCode="Role"
      routes={{
        newPath:  ()  =>  rolesRoute.new.build(),
        showPath: (id) => rolesRoute.show.build({id}),
        editPath: (id) => rolesRoute.edit.build({id})
      }}
      tableProps={{
        isLoading,
        rows,
        total,
        handleFetch,
        onDelete,
        schema: roleSchema,
        actions: ['show', 'edit', 'delete'],
        permissionKeyCode: 'Role',
        filterProps: {
          columns: roleSchema.filterColumns
        }
      }}
    />
  );
}

const mapStateToProps = state => ({
  isLoading: state.roles.listIsLoading,
  rows: state.roles.data,
  total: state.roles.totalData,
});

export default connect(mapStateToProps)(List);